import Button from '@eversports/react-components/primitives/Button'
import Divider from '@eversports/react-components/primitives/Divider'
import { SimpleFlex, VerticalFlex } from '@eversports/react-components/primitives/Flex'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { Localized } from '../localization/react'

interface Props {
  isForwardActionDisabled: boolean
  onGoBack?: () => void
  isCompletionStep?: boolean
}

const useStyles = makeStyles({
  container: {
    gap: '24px', // wide spacing
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})

const StepperActions: React.FC<React.PropsWithChildren<Props>> = ({
  onGoBack,
  isCompletionStep,
  isForwardActionDisabled,
}) => {
  const classes = useStyles()

  return (
    <VerticalFlex className={classes.container}>
      <Divider />
      <SimpleFlex className={classes.actions}>
        <div>
          {onGoBack && (
            <Button variant="secondary" onClick={onGoBack}>
              <Localized id="stepper-action-back" />
            </Button>
          )}
        </div>
        <Button type="submit" variant="primary" disabled={isForwardActionDisabled}>
          {isCompletionStep ? (
            <Localized id="stepper-action-complete-registration" />
          ) : (
            <Localized id="stepper-action-continue" />
          )}
        </Button>
      </SimpleFlex>
    </VerticalFlex>
  )
}

export default StepperActions
